import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {PageHtml5Service} from './page-html-5.service';

import {environment} from '../../../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {ProfileService} from '../../../shared-libs/service/profile.service';
import {ActivatedRoute} from '@angular/router';
import {ILandingPage} from './landing-page.model';
import {KeyValue} from '../landing-page/transactional-email.model';
import {LandingPageService} from './landing-page.service';

@Component({
    selector: 'landing-page-preview',
    templateUrl: './landing-page-preview.component.html',
    standalone: false
})
export class LandingPagePreviewComponent implements OnInit, OnChanges {

    items: KeyValue[] = [];
    item: KeyValue;

    urlPreview: string;
    landingPage: ILandingPage;

    idDataset: string;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected pageHtml5Service: PageHtml5Service,
        protected landingPageService: LandingPageService,
        protected sanitizer: DomSanitizer,
        protected profileService: ProfileService
    ) {

    }
    ngOnInit() {
        this.activatedRoute.data.subscribe(({ landingPage }) => {
          this.landingPage = landingPage;
        });
        this.landingPageService.getData(this.landingPage.code, "FR", "datasets").subscribe(data => {
            if(data && data[0]){
                this.items = data;
                this.item = data[0];
                this.idDataset = this.item.key;
            }
            this.updateIframe();
        })
    }

    updateIframe(){
        if(this.landingPage && this.landingPage.code && this.idDataset){
            this.urlPreview = `${environment.landingPagePreviewBaseUrl}/${this.profileService.getDatastore()}/TEST?lp=${this.landingPage.code}&lang=FR&param=${this.idDataset}`;
            //this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else if(this.landingPage && this.landingPage.code){
            this.urlPreview = `${environment.landingPagePreviewBaseUrl}/${this.profileService.getDatastore()}/TEST?lp=${this.landingPage.code}&lang=FR`;
            //this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
            this.urlPreview = null;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.landingPage){
            this.updateIframe();
        }
    }

    previousState() {
        window.history.back();
    }

    change(event){
        this.idDataset = event.value.key;
        this.updateIframe();
    }

}
